module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activities"
  }, [_c('ScrollDownDiv', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "auto"
    }
  }, [_vm._l((_vm.activities), function(activity, activityIndex) {
    return [_c('SpeechBubble', {
      key: activityIndex,
      staticClass: "mb-3",
      attrs: {
        "activity": activity
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-basis": "40px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newCommentText),
      expression: "newCommentText"
    }],
    staticClass: "add-comment-box",
    attrs: {
      "type": "text",
      "placeholder": "Add a comment..."
    },
    domProps: {
      "value": (_vm.newCommentText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.saveComment($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newCommentText = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7677a87d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/activity/Activities.vue
// module id = 2611
// module chunks = 1